class AtcButton {

  constructor() {
    this.addClickEventListener();
  }

  addClickEventListener() {
    jQuery('body').on(
      'click',
      '.atc-button',
      (event) => {
        let button = jQuery(event.currentTarget);

        this.addToCart(
          button.data('handle'),
          button.data('variant-id')
        );
      }
    );
  }

  async addToCart(handle, variantId) {
    if (!await this.applyFilters('should_add_to_cart', true, { handle: handle, variantId: variantId })) {
      return;
    }

    variantId = await this.applyFilters('variant_id', variantId, { handle: handle });

    const response = await fetch('/cart/add.js?id=' + variantId);

    if (302 !== response.status && 200 !== response.status) {
      return;
    }

    location.href = '/cart';
  }

}

(async() => {
  // Wait for dependencies to load.
  await new Promise(
    (resolve) => {
      let interval = setInterval(
        () => {
          if (typeof jQuery == 'undefined') {
            return;
          }
          if (typeof traitHasFilters == 'undefined') {
            return;
          }
          clearInterval(interval);
          resolve();
        },
        10
      )
    }
  );

  // Assign traits.
  Object.assign(AtcButton.prototype, traitHasFilters);

  // Initialize functionality.
  jQuery(document).ready(
    () => {
      window.atcButton = new AtcButton();
    }
  );
})();